import Vue from 'vue';

Vue.component('clawback-index-es', () =>
    import(/* webpackChunkName: 'clawback-index-es' */ './clawback-index-es.vue'),
);

Vue.component('clawback-filter', () =>
    import(/* webpackChunkName: 'clawback-filter' */ './clawback-filter.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/clawback/index.js